
















import { Component, Vue } from 'vue-property-decorator';
import FeatureCard from './FeatureCard.vue';
// @ts-ignore
import kaaba from '../assets/kaaba.svg';
// @ts-ignore
import mosque from '../assets/mosque.svg';
// @ts-ignore
import hotel from '../assets/hotel.svg';

interface Feature {
    name: string,
    description: string,
    image: string
}



@Component({
    name: 'alzuhud-header',
    components: {
        FeatureCard
    }
})
export default class AlzuhudHeader extends Vue {
    features: Array<Feature>;
    /**
     *
     */
    constructor() {
        super();
        this.features = [
            {
                name: 'Ummrah Services',
                description: 'We are here in Al-Zuhud directing and allocating ways of care and comfort for Hajj or Ummrah to enable the guests of the Rahman to devote full time to worship without hardship or trouble. ',
                image: kaaba
            },
            {
                name: 'Beautiful Facilities',
                description: 'We always make sure all our facilities ensure quality and comfort. Zahd for Hajj and Ummrah services is always seeking to provide the best services to our guests',
                image: hotel
            },
            {
                name: 'Visitor Services',
                description: 'Providing all the amenities and safety of transportation and guidance services and the organization of the arbitrator in addition to the expansions in the vast areas of the Holy Mosque and the Prophet’s Mosque.',
                image: mosque
            }
        ];     
    }  
}
